import React from 'react';
import {StandardPageHeight} from "../../../playground/standard-page-framework";

export const PageContainer = ({children,onDragOver=()=>{},no_padding}) => {
    return <StandardPageHeight>
        {children}
    </StandardPageHeight>
};